import React from 'react';
import { useIntl } from 'react-intl';

import css from './Description.module.css';

const Description = ({ title = '', description = '', url = '', reservationUrl = '' }) => {
  const intl = useIntl();
  const content = description.replace(/<a .*>(.*)<\/a>/gi, '$1');

  const linkText = reservationUrl
    ? intl.formatMessage({ defaultMessage: 'Book your trip to {title}', id: '3oJ7sk' }, { title })
    : intl.formatMessage({ defaultMessage: 'Read more about {title}', id: 'Q+HrZK' }, { title });

  return (
    <React.Fragment>
      {content && (
        <React.Fragment>
          <div className={`flex mb-4 lg:mb-8 ${css.description}`}>
            <div className="flex flex-col items-start w-full grow">
              <div
                className={`text-lg text-gray-900 ${css.hidetitles}`}
                dangerouslySetInnerHTML={{ __html: content }}
              />
              {reservationUrl ? (
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2 text-lg font-medium text-gray-800 focus:outline-none">
                  {linkText}
                </a>
              ) : (
                <a href={url} className="mt-2 text-lg font-medium text-gray-800 focus:outline-none">
                  {linkText}
                </a>
              )}
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default Description;
